import {object, string} from 'yup';
import {COUNTRIES} from '../../../../../../../../../constants/countries';
import MAPPED_TO_ITEMS from '../constants/mappedTo';

const getID = (el) => el.id;

export default object({
  coin: string().oneOf(COUNTRIES.map((el) => el[1])).required(),
  network: string().oneOf(COUNTRIES.map((el) => el[1])).required(),
  address: string().required(),
  mapped_to: string().oneOf(MAPPED_TO_ITEMS.map(getID)).required()
});
